// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.excel-upload-container {
    background-color: white;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    margin-top: 80px;
  }
  
  .excel-upload-title {
    color: #003366;
    text-align: center;
    margin-bottom: 30px;
    font-size: 28px;
    font-weight: bold;
  }`, "",{"version":3,"sources":["webpack://./src/components/Configuration/ExcelUpload/ExcelUpload.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB","sourcesContent":[".excel-upload-container {\n    background-color: white;\n    padding: 30px;\n    border-radius: 10px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    margin-top: 80px;\n  }\n  \n  .excel-upload-title {\n    color: #003366;\n    text-align: center;\n    margin-bottom: 30px;\n    font-size: 28px;\n    font-weight: bold;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
